module.exports = __webpack_public_path__ + "img/st-vincent-and-the-grenadines.cfe9e916.svg";